import { makeStyles, Paper, TextField, Theme, Typography } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import React from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionTitle } from '../../components/SectionTitle';
import { globalStyles } from '../../style/GlobalStyles';
import { DefaultInputProps } from '../../types/types';

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         formControl: {
//             margin: theme.spacing(1),
//             // minWidth: 320,
//         },
//         textField: {
//             marginLeft: theme.spacing(1),
//             marginRight: theme.spacing(1),
//             width: 200,
//         },
//         bottomControlLabel: {
//             verticalAlign: 'bottom',
//         }
//     }),
// );

export default function IrpefImprenditore(props: DefaultInputProps) {
    // const classes = useStyles();
    const gClasses = globalStyles();
    const { state } = props;
    return (
        <Paper className={gClasses.mainPaper}>
            <SectionTitle text="Imprenditore/Professionista"></SectionTitle>
            <TextField
                label="Imprenditore/professionista"
                value={state.nomeCognome}
                className={gClasses.textFieldReadOnly}
                InputLabelProps={{
                    shrink: true,
                    disabled: true
                }}
                margin="normal"
            />
            <Typography variant="h5">Contributi</Typography>
            <NumberField
                name=""
                label="Contributi"
                value={state.irpefImprenditore.I29}
                className={gClasses.textFieldReadOnly}
                readOnly={true}
            />
            <Typography variant="h5">Redditi</Typography>
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E98"
                label="Pensione"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E98}
                className={gClasses.textFieldReadOnly}
                readOnly={true}
            />
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E99"
                label="Lav. dipendente e assimilati"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E99}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E100"
                label="Assimilati lav. dipendente"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E100}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Reddito d'impresa/lav. auton."
                value={state.irpefImprenditore.E12}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E101"
                label="Diversi lettere i) e l)"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E101}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E102"
                label="Fabbricati locati"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E102}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E103"
                label="Altri"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E103}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E104"
                label="Abitazione principale"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E104}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E105"
                label="Redditi a cedolare secca"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E105}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Reddito complessivo"
                value={state.irpefImprenditore.E20}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Redd. compl. per detraz."
                value={state.irpefImprenditore.E21}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Oneri deducibili"
                value={state.irpefImprenditore.I9}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Reddito imponibile"
                value={state.irpefImprenditore.I10}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Irpef lorda"
                value={state.irpefImprenditore.I11}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <Typography variant="h5">Detrazioni</Typography>
            <NumberField
                name=""
                label="Familiari a carico"
                value={state.irpefImprenditore.I13}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Lavoro dipend."
                value={state.irpefImprenditore.I14}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Pensione"
                value={state.irpefImprenditore.I15}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Lav. non dipend."
                value={state.irpefImprenditore.I16}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Altre"
                value={state.liquidazioneIrpef.altriDatiPersonali_L102}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Tot. Detrazioni"
                value={state.irpefImprenditore.I18}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Irpef netta"
                value={state.irpefImprenditore.M14}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <Typography variant="h5">Addizionali Irpef</Typography>
            <NumberField
                name=""
                label="Regionale"
                value={state.irpefImprenditore.K18}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name=""
                label="Comunale"
                value={state.irpefImprenditore.M18}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
        </Paper>
    );
}